import { Component, OnInit, inject } from '@angular/core';
import { ITracker, IUpdateTracker } from 'modelos/src';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';
import { ParamsService } from '../../../../../auxiliares/servicios/params.service';
import { LoginService } from '../../../../login/login.service';
import { ThemesService } from '../../../../../auxiliares/servicios/themes.service';
import { TrackersService } from '../../../../../auxiliares/servicios/http/trackers.service';

@Component({
  selector: 'app-dar-alta-tracker',
  templateUrl: './dar-alta-tracker.component.html',
  styleUrl: './dar-alta-tracker.component.scss',
  standalone: false,
})
export class DarAltaTrackerComponent implements OnInit {
  data = inject<{
    edit?: ITracker;
  }>(MAT_DIALOG_DATA);
  dialog = inject(MatDialog);
  helper = inject(HelperService);
  private service = inject(TrackersService);
  dialogRef = inject<MatDialogRef<DarAltaTrackerComponent>>(MatDialogRef);
  paramsService = inject(ParamsService);
  themesService = inject(ThemesService);

  public selectedFechaAlta: string; // Variable temporal para almacenar la fecha seleccionada
  public fechaAlta: string;
  public maxDate: Date = new Date();
  public clientePropio = LoginService.getCliente();
  public loading = false;
  public title?: string;

  public urlImagenes: string[] = [];

  ///////////////////////////////////////////////////////////////////////////////////
  // Método para manejar el cambio de la fecha

  onDateTimeChange(event: any) {
    this.selectedFechaAlta = event.value; // Actualiza fechaAlta solo cuando el usuario seleccione una fecha
  }

  public async onSubmit() {
    this.loading = true;
    try {
      let res;
      if (this.selectedFechaAlta) {
        //Si tiene fecha selected es porque se está queriendo dar de alta
        // Dar de alta
        const data = this.getDataAlta();
        res = await this.service.update(this.data.edit._id, data);
        this.helper.notifSuccess('Dado de alta correctamente');
      } else {
        // Actualizar imágenes
        const data = this.getDataActualizar();
        res = await this.service.update(this.data.edit._id, data);
        this.helper.notifSuccess('Imágenes de alta actualizadas');
      }
      this.dialogRef.close(res);
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
    this.loading = false;
  }

  public getDataAlta(): IUpdateTracker {
    const data: IUpdateTracker = {
      imagenes: this.urlImagenes,
      fechaAlta: this.selectedFechaAlta,
    };
    return data;
  }

  public getDataActualizar(): IUpdateTracker {
    const data: IUpdateTracker = {
      imagenes: this.urlImagenes,
    };
    return data;
  }

  /////////////////////////////////////////////////////////////////////////////
  //HOOKS

  ngOnInit() {
    if (this.data.edit?._id && this.data.edit?.fechaAlta) {
      this.fechaAlta = this.data.edit.fechaAlta;
      this.urlImagenes = this.data.edit.imagenes;
    } else {
      this.fechaAlta = null;
      this.urlImagenes = this.data.edit.imagenes;
    }
    this.title = this.fechaAlta
      ? `Actualizar imágenes de ${this.data?.edit?.nombre}`
      : `Dar de alta ${this.data?.edit?.nombre}`;
  }
}
